import React from "react";
import {useRowSelect, useTable} from "react-table";
import IndeterminateCheckbox from "../WarehouseTable/IndeterminateCheckbox";
import {useSticky} from "react-table-sticky";

export interface ITableRowProductsShipment {
    sku?: string,
    barcode: string,
    name?: string,
    shipment?: string,
    inStock?: string,
    stocksPR?: string,
    acceptance?: string,
    discrepancy?: string,
}

interface ITableProductsShipmentProps {
    data: ITableRowProductsShipment[],
}

const TableProductsShipment: React.FC<ITableProductsShipmentProps> = ({
    data,
}) => {

    const columns = React.useMemo(
        () => [
            {
                Header: 'Артикул',
                accessor: 'sku',
                sticky: 'left',
                minWidth: 140,
                width: 140,
            },
            {
                Header: 'Штрихкод',
                accessor: 'barcode',
                sticky: 'left',
                minWidth: 125,
                width: 125,
            },
            {
                Header: 'Наименование',
                accessor: 'name',
                minWidth: 300,
                width: "100%",
            },
            {
                Header: 'В отгрузку',
                accessor: 'inStock',
                minWidth: 140,
            },
            {
                Header: 'В наличии',
                accessor: 'stocksPR',
                minWidth: 140,
            },
            {
                Header: 'Склад ПР',
                accessor: 'acceptance',
                minWidth: 140,
            },
            {
                Header: 'Расхождения',
                accessor: 'discrepancy',
                minWidth: 140,
            },
        ],
        [],
    )

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({
        columns,
        data,
    } as any,
        useSticky,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => [
                {
                    id: 'selection',
                    Header: ({ getToggleAllRowsSelectedProps }) => (
                        <div className="flex justify-center content-center">
                            <IndeterminateCheckbox
                                name=""
                                {...getToggleAllRowsSelectedProps()}
                            />
                        </div>
                    ),
                    Cell: ({ row }: any) => (
                        <div className="flex justify-center content-center">
                            <IndeterminateCheckbox
                                name=""
                                {...row.getToggleRowSelectedProps()}
                            />
                        </div>
                    ),
                    minWidth: 34,
                    maxWidth: 34,
                    width: 34,
                    sticky: 'left',
                },
                ...columns,
            ]);
        }
    )

    return (
        <div className="w-full overflow-hidden">
            <div className="overflow-auto rounded-sm">
                <table {...getTableProps()} className="react-table sticky">
                    <thead className="header">
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => {
                                return(
                                    <th {
                                            ...column.getHeaderProps(
                                                {
                                                    style: { minWidth: column.minWidth, width: column.width, maxWidth: column.maxWidth },
                                                })
                                        }>{column.render('Header')}</th>
                                )
                            })}
                        </tr>
                    ))}
                    </thead>
                    <tbody {...getTableBodyProps()} className="body">
                    {rows.map((row) => {
                        prepareRow(row)
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map(cell => {
                                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                })}
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </div>
        </div>

    )
}

export default TableProductsShipment;